<template>
  <b-container fluid>
    <b-row v-if="total>0">
      <b-col cols="12" md="4">
        <div class="summary">
          {{ $t('products_viewer_pagination.showing_items', {
            start: start,
            end: end,
            total: total
          }) }}
        </div>
      </b-col>
      <b-col cols="12" md="4" class="mt-3 mt-md-0">
        <Pagination
          v-if="perPage < total"
          :total="total"
          :perPage="perPage"
          v-bind:value="value"
          v-on:input="onInput"
        />
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import Pagination from "@/components/Pagination";

export default {
  name: "products-viewer-pagination",
  components: {
    Pagination,
  },
  props: {
    start: Number,
    end: Number,
    total: Number,
    perPage: Number,
    value: Number,
  },
  methods: {
    onInput (value) {
      this.$emit('input', value);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        products_viewer_pagination: {
          showing_items: "Showing {start}-{end} of {total} items.",
          prev: "Prev",
          next: "Next",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
@include media-breakpoint-down(sm) {
  .summary {
    text-align: center;
  }
}

ul ::v-deep li {
  margin-right: 0.5rem;
}

ul ::v-deep li:first-child ::v-deep .page-link,
ul ::v-deep li:last-child ::v-deep .page-link {
  border: none;
  white-space: nowrap;
}

ul ::v-deep li.page-item.active ::v-deep .page-link {
  background-color: $corp-color2;
  border-color: $corp-color2;
}

::v-deep a.page-link {
  color: $text-main-color;

  &:hover {
    color: $text-main-color;
  }
}
</style>
